import 'react-perfect-scrollbar/dist/css/styles.css'
import 'nprogress/nprogress.css'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom'
import { HelmetProvider } from 'react-helmet-async'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Provider as ReduxProvider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import StyledEngineProvider from '@mui/material/StyledEngineProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

import App from './App'
import { AuthProvider } from './contexts/Auth0Context'
import { SettingsProvider } from './template/material-kit-pro/contexts/SettingsContext'
import store from './template/material-kit-pro/store'

const queryClient = new QueryClient()

ReactDOM.render(
  <StrictMode>
    <HelmetProvider>
      <ReduxProvider store={store}>
        <StyledEngineProvider injectFirst>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <SettingsProvider>
              <BrowserRouter>
                <QueryClientProvider client={queryClient}>
                  <AuthProvider>
                    <App />
                  </AuthProvider>
                </QueryClientProvider>
              </BrowserRouter>
            </SettingsProvider>
          </LocalizationProvider>
        </StyledEngineProvider>
      </ReduxProvider>
    </HelmetProvider>
  </StrictMode>,
  document.getElementById('root'),
)
